import React from 'react'
import Loadable from 'react-loadable';

import {
  BrowserRouter as Router,
  Route,
  Switch,
  Link
} from 'react-router-dom';

// This component allows for code splitting. 
import LoadingComponent from './LoadingComponent.jsx';
import { Collection } from 'mongoose';

// Use dynamic import statement for routes to allows for code splitting.
const Activities = Loadable({
  loader: () => import('./components/discover/DiscoverPage.jsx'),
  loading() {
    return <LoadingComponent/>
  }
});
const ActivityWithData = Loadable({
  loader: () => import('./components/activity/ActivityWithData.jsx'),
  loading() {
    return <LoadingComponent/>
  }
});
const WorksheetBuilder = Loadable({
  loader: () => import('./components/worksheetBuilder/WorksheetBuilder.jsx'),
  loading() {
    return <LoadingComponent/>
  }
});
const Login = Loadable({
  loader: () => import('./components/auth/Login.jsx'),
  loading() {
    return <LoadingComponent/>
  }
});
const ProfileWithData = Loadable({
  loader: () => import('./components/user/ProfileWithData.jsx'),
  loading() {
    return <LoadingComponent/>
  }
});

const MatrixWrapper = Loadable({
  loader: () => import('./components/matrix/MatrixWrapper.jsx'),
  loading() {
    return <LoadingComponent />
  }
});

const Folio = Loadable({
  loader: () => import('./components/folio/Folio.jsx'),
  loading() {
    return <LoadingComponent />
  }
});

const Workshop = Loadable({
  loader: () => import('./components/project/ProjectListWithData.jsx'),
  loading() {
    return <LoadingComponent />
  }
});

const ProjectForm = Loadable({
  loader: () => import('./components/project/ProjectFormWithData.jsx'),
  loading() {
    return <LoadingComponent />
  }
});

const Project = Loadable({
  loader: () => import('./components/project/ProjectWithData.jsx'),
  loading() {
    return <LoadingComponent />
  }
});

const ProjectTemplate = Loadable({
  loader: () => import('./components/project/ProjectTemplateWithDaja.jsx'),
  loading() {
    return <LoadingComponent />
  }
});

const WorksheetWithData = Loadable({
  loader: () => import('./components/worksheet/WorksheetWithData.jsx'),
  loading() {
    return <LoadingComponent />
  }
});

const PasswordReset = (props) => <Login form="reset" {...props}/>;

const SchoolAdminWithData = Loadable({
  loader: () => import('./components/admin/schoolList/SchoolAdminWithData.jsx'),
  loading() {
    return <LoadingComponent />
  }
});

const StudentListWithDataWrapper = Loadable({
  loader: () => import('./components/admin/studentList/StudentListWithDataWrapper.jsx'),
  loading() {
    return <LoadingComponent />
  }
});

const AdminListWithDataWrapper = Loadable({
  loader: () => import('./components/admin/adminList/AdminListWithDataWrapper.jsx'),
  loading() {
    return <LoadingComponent />
  }
});

const ClassListWithDataWrapper = Loadable({
  loader: () => import('./components/admin/classList/ClassListWithDataWrapper.jsx'),
  loading() {
    return <LoadingComponent />
  }
});

const LibraryWithData = Loadable({
  loader: () => import('./components/library/LibraryWithData.jsx'),
  loading() {
    return <LoadingComponent />
  }
});

const TeacherDashboardWithData = Loadable({
  loader: () => import('./components/admin/teacherDashboard/TeacherDashboardWithData.jsx'),
  loading() {
    return <LoadingComponent />
  }
});

// This receives the jwt token from the api, and saves it to localstorage via query string.
// @todo move it from query string to the header or else hit the google api from the client side.
const GoogleAuth = Loadable({
  loader: () => import('./components/auth/GoogleAuth.jsx'),
  loading() {
    return <LoadingComponent />
  }
});

// Use dynamic import statement for routes to allows for code splitting.
const TagAdmin = Loadable({
  loader: () => import('./../components/components/admin/actionlab/TagAdminWithData.jsx'),
  loading() {
    return <LoadingComponent />
  }
});

// Use dynamic import statement for routes to allows for code splitting.
const ActivitySort = Loadable({
  loader: () => import('./../components/components/admin/actionlab/ActivitySortWithData.jsx'),
  loading() {
    return <LoadingComponent />
  }
});

const Terms = Loadable({
  loader: () => import('./../components/pages/Terms.jsx'),
  loading() {
    return <LoadingComponent />
  }
});

// Use dynamic import statement for routes to allows for code splitting.
const StudioAdmin = Loadable({
  loader: () => import('./../components/components/admin/actionlab/StudioListWithData.jsx'),
  loading() {
    return <LoadingComponent />
  }
});

const CollectionPathListWithData = Loadable({
  loader: () => import('./../components/components/collectionPath/CollectionPathListWithData.jsx'),
  loading() {
    return <LoadingComponent />
  }
});

const CollectionPathWrapper = Loadable({
  loader: () => import('./../components/components/collectionPath/CollectionPathWrapper.jsx'),
  loading() {
    return <LoadingComponent />
  }
});

const CollectionTemplate = Loadable({
  loader: () => import('./../components/components/collectionPath/CollectionTemplate.jsx'),
  loading() {
    return <LoadingComponent />
  }
});

const Routes = () => {
  return (
    <Router>
      <div>
        <Switch>
          <Route exact path="/" component={Activities} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/user/:_id" component={ProfileWithData} form="login" />
          <Route exact path="/user/reset/:token" component={PasswordReset} />
          <Route exact path="/discover" component={Activities} />
          <Route exact path="/discover/:id" component={Activities} />
          <Route exact path="/folio" component={Folio} />
          <Route exact path="/matrix" component={MatrixWrapper} />
          <Route exact path="/workshop" component={Workshop} />
          <Route exact path="/activity/:slug" component={ActivityWithData} />
          <Route exact path="/worksheet-builder" component={WorksheetBuilder} />
          <Route exact path="/project/:_id" component={Project} />
          <Route exact path="/project-template/:_id" component={ProjectTemplate} />
          <Route exact path="/worksheet/:_id" component={WorksheetWithData} />
          <Route exact path="/admin/schools" component={SchoolAdminWithData} />
          <Route exact path="/admin/students" component={StudentListWithDataWrapper} />
          <Route exact path="/admin/accounts" component={AdminListWithDataWrapper} />
          <Route exact path="/admin/classes" component={ClassListWithDataWrapper} />
          <Route exact path="/library" component={LibraryWithData} />
          <Route exact path="/admin/dashboard" component={TeacherDashboardWithData} />
          <Route exact path="/admin/tag" component={TagAdmin} />
          <Route exact path="/admin/activity-sort" component={ActivitySort} />
          <Route exact path="/admin/studios" component={StudioAdmin} />
          <Route exact path="/collections" component={CollectionPathListWithData} />
          <Route exact path="/collection/:_id" component={CollectionPathWrapper} />
          <Route exact path="/collection-template/:_id" component={CollectionTemplate} />
          <Route exact path="/google-auth" component={GoogleAuth} />
          <Route exact path="/terms-and-conditions" component={Terms} />
        </Switch>
      </div>
    </Router>
  );
};

export default Routes;


// WEBPACK FOOTER //
// ./src/components/Routes.jsx